import { render, staticRenderFns } from "./OtherProductsModal.vue?vue&type=template&id=2f498340&scoped=true&"
import script from "./OtherProductsModal.vue?vue&type=script&lang=ts&"
export * from "./OtherProductsModal.vue?vue&type=script&lang=ts&"
import style0 from "./OtherProductsModal.vue?vue&type=style&index=0&id=2f498340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f498340",
  null
  
)

export default component.exports